export default function () {
  // Apply filter
  $(".applyFilters").click(function () {
    let params = {};

    let inputs = $(this).closest(".dropdown-menu").find("input");
    inputs.each(function () {
      let inputType = $(this).attr("type");
      let val = $(this).val();
      let paramKey = $(this).attr("data-param-key");

      if (inputType === "checkbox" || inputType === "radio") {
        if (
          $(this).is(":checked") &&
          val.length !== 0 &&
          typeof paramKey !== "undefined"
        ) {
          params[paramKey] = val;
        }
      } else if (
        inputType === "hidden" &&
        $(this).attr("id") === "temp_categories_input"
      ) {
        // Handle temporary category selections
        if (val.length !== 0 && typeof paramKey !== "undefined") {
          params[paramKey] = val;
        }
      } else {
        // Skip the regular categories input since we use temp_categories_input now
        if ($(this).attr("id") !== "search_categories") {
          if (val.length !== 0 && typeof paramKey !== "undefined") {
            params[paramKey] = val;
          }
        }
      }
    });

    let url = window.location.pathname;
    Turbo.visit(url + "?" + $.param(params));
  });
}
